import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deleteRule: {
    id: `app.containers.WorkflowEditor.components.Rules.PartnerRules.PartnerRuleCard.deleteRule`,
    defaultMessage: 'Delete Rule',
  },
  ruleNumber: {
    id: `app.containers.WorkflowEditor.components.Rules.PartnerRules.PartnerRuleCard.ruleNumber`,
    defaultMessage: 'Rule {number}',
  },
});
